import React from "react";

const RetireIcon = ({ size = 16, className }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 14.667h4c3.334 0 4.667-1.333 4.667-4.667V6c0-3.333-1.333-4.666-4.666-4.666H6C2.667 1.334 1.334 2.667 1.334 6v4c0 3.334 1.333 4.667 4.667 4.667"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M10.587 9.667v-3.28a2.054 2.054 0 0 0-4.107 0V10.9"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.514 9.953 6.461 11 5.414 9.953"
        />
      </svg>
    </span>
  );
};

export default RetireIcon;
